export default {
  // 是否启用埋点.
  useTracer: true,
  // 若启用埋点，则需要配置初始化选项.
  projectConfig: {
    //环境只分为stage和线上
    env: location.href.includes('https://www.meicai.cn') ? 'production' : 'stage',
    autoPilot: true,
    //页面有埋点时必须配置路由的pageId
    routeMap: {
      '#/': {
        pageId: 3914,
        url: '/#/'
      }
    },
    routePathName: window.location.pathname, //pathName前缀
    //根路径
    routeUrlPrefix: 'https://www.meicai.cn'
  },
  baseParam: {
    uid: '', //用户id
    device_id: randomDeviceId(), //设备id,无需修改
    net: "wifi",
    app_version: '0.1.0',
    app_system: "web",
    app_runtime: 'native',
    app_id: 52, //需改为自己的app_id
    latitude: '',
    longitude: ''
  }
}


function randomDeviceId() {
  var result = "";
  if (localStorage.getItem("device_id")) {
    result = localStorage.getItem("device_id");
  } else {
    var data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    for (var i = 0; i < 20; i++) {
      let r = Math.floor(Math.random() * 16);
      result += data[r];
    }
    localStorage.setItem("device_id", result);
  }
  return result;
}